import { useEffect } from "react";
import { motion } from "framer-motion";

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title
      ? `${title} | JOELL Asphalt & Maintenance Bermuda`
      : "JOELL Asphalt Service & Maintenance Ltd. | Bermuda Asphalt Paving, Construction, Demolition & Property Maintenance";
  }, [title]);
};

export function Reveal({ children, delay = 0, className = "", y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export const roadArrow = (
  <span aria-hidden="true" className="inline-block h-2 w-2 rotate-45 border-t-2 border-r-2 border-joell-green" />
);

export function Eyebrow({ children, className = "" }) {
  return (
    <p className={`eyebrow flex items-center gap-3 ${className}`}>
      {roadArrow}
      {children}
    </p>
  );
}

export function SectionHead({ eyebrow, title, sub, center = false, className = "" }) {
  return (
    <Reveal className={`mb-12 max-w-3xl md:mb-16 ${center ? "mx-auto text-center" : ""} ${className}`}>
      {eyebrow && (
        <div className={center ? "flex justify-center" : ""}>
          <Eyebrow className="mb-4">{eyebrow}</Eyebrow>
        </div>
      )}
      <h2 className="font-display text-3xl font-bold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title}
      </h2>
      {sub && <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">{sub}</p>}
    </Reveal>
  );
}

export function Marquee({ items }) {
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-joell-coal/60 py-5" data-testid="home-marquee">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} aria-hidden={dup === 1} className="flex shrink-0 items-center">
            {items.map((t) => (
              <span
                key={t}
                className="flex items-center font-display text-lg font-semibold uppercase tracking-[0.25em] text-white/60"
              >
                <span className="whitespace-nowrap px-8">{t}</span>
                <span aria-hidden="true" className="inline-block h-2 w-2 rotate-45 border-t-2 border-r-2 border-joell-green" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function RoadDash({ green = false, className = "" }) {
  return <div aria-hidden="true" className={`${green ? "road-dash-green" : "road-dash"} ${className}`} />;
}
